import React from 'react';

import { AgChartsReact } from 'ag-charts-react';

const AGChart = ({ options, ...rest }) => {
  return <AgChartsReact options={options} {...rest} />;
};

export default AGChart;
